import { useQuery } from '@tanstack/react-query'
import { useTypedApiClient } from 'hooks/useTypedApiClient'

export const useGetSweepstakeByIdWithGroupDrawingInfo = (id: number) => {
  const get = useTypedApiClient({
    path: '/admin/contests/{id}/drawing-info/multi-draw',
    method: 'get',
  })

  return useQuery({
    queryKey: ['/sweepstakes/drawing-info/multi-draw', id],
    queryFn: async () => {
      const { data } = await get({ id })
      return data
    },
  })
}
